/**
 * @license Copyright (c) 2023-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */

export function getBlockComment( lines: Array<string> ): string {
	return [
		'/**',
		...lines.map( line => ` * ${ line }` ),
		' */'
	].join( '\n' );
}
